import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const SubMenu = ({
    anchorEl,
    setAnchorEl,
    submenuItems
}) => {
    return (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            open={Boolean(anchorEl)}
            onClick={() => setAnchorEl(null)}
            sx={{
                display: {
                    xs: "none",
                    md: "block"
                },
                zIndex: 1999,
                textAlign: "center"
            }}
        >
            {submenuItems.map((item, index) => (
                <MenuItem sx={{ p: 0 }} key={`${Math.random()}_${index}`}>
                    <Link to={item.to} className="w-full px-6 py-1">
                        {item.text}
                    </Link>
                </MenuItem>
            ))}
        </Menu>
    );
}

export default SubMenu;
